module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Bob Greatorex is a retired surgeon who trained as both a dental and general surgeon. He spent forty years working in the NHS and alongside clinical work, became an experienced teacher, trainer and examiner in the UK and internationally. Elected to the Council of the Royal College of Surgeons of England, he was seconded onto national committees within the Department of Health. Away from the clinical coalface, he worked for the Care Quality Commission and the Centre for Workforce Intelligence. He is a champion of equality and diversity within the profession and is an enthusiastic supporter of Women in Surgery.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0